<div class="cartorio-container">
  <h1 class="titulo">Registros</h1>
  <form class="form-registros">
    <div class="form-group">
      <label for="data">Data</label>
      <input type="date" id="data" class="form-control" name="data">
    </div>
    <div class="form-group">
      <label for="resumo">Resumo</label>
      <input type="text" id="resumo" class="form-control" name="resumo" placeholder="Digite um resumo">
    </div>
    <div class="form-group">
      <label for="consideracoes">Considerações</label>
      <textarea id="consideracoes" class="form-control" name="consideracoes" rows="3" placeholder="Digite as considerações"></textarea>
    </div>
    <div class="form-group">
      <label for="proximosPassos">Próximos Passos</label>
      <textarea id="proximosPassos" class="form-control" name="proximosPassos" rows="2" placeholder="Digite os próximos passos"></textarea>
    </div>
    <button type="submit" class="btn btn-primary">Salvar</button>
  </form>
</div>

<style>
.cartorio-container {
  max-width: 500px;
  margin: 2rem auto;
  padding: 2rem;
  background: #f8fafc;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(44, 131, 179, 0.08);
}
.titulo {
  text-align: center;
  margin-bottom: 2rem;
  color: #153658;
}
.form-registros .form-group {
  margin-bottom: 1.5rem;
}
.form-registros label {
  font-weight: 500;
  color: #153658;
  margin-bottom: 0.5rem;
  display: block;
}
.form-registros .form-control {
  width: 100%;
  padding: 0.7em;
  border: 1px solid #e0e7ef;
  border-radius: 8px;
  font-size: 1rem;
  box-sizing: border-box;
}
.btn-primary {
  background: #2c83b3;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.7em 2em;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-primary:hover {
  background: #1e5a7a;
}
</style>
